import { Fragment, useState } from 'react';

import { theme } from '@prose-ui';
import { styled } from '@prose-ui/legacy';

import Spacer from 'Components/Spacer';
import { Typography } from 'Components/Typography';

import { featuredReviews } from 'assets/content/reviews/featuredReviews';

import { Review } from './UserReview';

const resetButtonCss = `
    border: none;
    margin: 0;
    padding: 0;
    width: auto;
    overflow: visible;

    background: transparent;

    color: inherit;
    font: inherit;

    line-height: normal;

    -webkit-font-smoothing: inherit;
    -moz-osx-font-smoothing: inherit;

    -webkit-appearance: none;`;

const TabWrapper = styled.div`
  width: 100%;
  display: flex;
  gap: ${theme.spacing['6x']};
`;

const TabButton = styled.button<{ activeTab?: boolean }>`
  ${resetButtonCss}
  cursor: pointer;
  border-bottom: 3px solid;
  border-color: ${({ activeTab }) => (activeTab ? ` ${theme.colors.accent[300]}` : 'transparent')};

  &:hover {
    border-bottom: 3px solid ${theme.colors.accent[300]};
  }
`;

const StyledTabButtonText = styled(Typography)`
  margin-bottom: ${theme.spacing['1x']};
`;

const Divider = styled.span`
  display: block;
  width: 100%;
  height: 1px;

  background-color: var(--color-background, ${theme.colors.neutral[100]});
`;

export const UserReviewsTab = () => {
  const [activeTab, setActiveTab] = useState(0); // 0 for skincare, 1 for haircare
  const reviewsContent = featuredReviews[activeTab]?.reviews;
  const tabTitle = featuredReviews[activeTab]?.title;

  return (
    <>
      <TabWrapper>
        {featuredReviews.map((tab, index) => (
          <TabButton
            key={tab.title}
            activeTab={activeTab === index}
            data-testid={`${tab.title}-tab-button`}
            onClick={() => setActiveTab(index)}
          >
            <StyledTabButtonText markupName="h2" upperCase variant="mono1">
              {tab.title}
            </StyledTabButtonText>
          </TabButton>
        ))}
      </TabWrapper>

      <Divider
        style={{
          '--color-background': theme.colors.neutral[600],
        }}
      />
      <div data-testid={`${tabTitle}-tab-content`}>
        {reviewsContent?.map(({ date, displayName, ratings, text }) => (
          <Fragment key={`${displayName}-${date}`}>
            <Divider
              style={{
                '--color-background': theme.colors.neutral[600],
              }}
            />
            <Spacer size={48} />
            {/* @ts-expect-error -(@nelly)  TODO: fix TS error */}
            <Review date={date} displayName={displayName} ratings={ratings} text={text} />
            <Spacer size={36} />
          </Fragment>
        ))}
      </div>
    </>
  );
};
